import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { HttpService } from '../http/http.service';
import { environment } from 'environments/environment';
import { apiConstant } from '../constant/apiConstant';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as FeatureFlagsActions from './feature-flags.actions';

@Injectable()
export class FeatureFlagsEffects {
  constructor(private actions$: Actions, private httpService: HttpService) {}

  loadFeatureFlags$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FeatureFlagsActions.loadFeatureFlags),
      mergeMap(() =>
        this.httpService.get(`${environment.baseUrl}${apiConstant.systemFeature}`).pipe(
          map((response) =>
            FeatureFlagsActions.loadFeatureFlagsSuccess({ featureFlags: response?.result || {} })
          ),
          catchError((error) => of(FeatureFlagsActions.loadFeatureFlagsFailure({ error })))
        )
      )
    )
  );
}
